module.exports = __webpack_public_path__ + "static/media/correct.0f7bf2be.png";